// extracted by mini-css-extract-plugin
export default {"form-group":"adminPurchasedOrders_form-group__bsx9l","container":"adminPurchasedOrders_container__u67+z"};